import DesignTokens from '@tableau/design-tokens';
import React from 'react';
import { style } from 'typestyle';

import { CommonStyles } from '~commonInfra/styles/CommonStyles';

export const textFieldStyles = style({
  marginTop: '16px',
  width: '100%',
});

export const dataGridContainerStyle = style({
  borderBottom: `1px solid ${DesignTokens.color.elevation.border.default.subtle}`,
  marginBottom: '16px',
  $nest: {
    '.tb-react-dg-body': {
      overflowX: 'hidden !important' as any,
    },
  },
});

export const dataGridStyle: React.CSSProperties = {
  overflow: 'hidden',
  padding: '0px',
  marginTop: `${CommonStyles.Sizes.LineHeight}px`,
  zIndex: 'auto',
  height: 305,
};

export const dataGridRowHeight = 32;
